module.exports = "/images/Sell products online.svg?0558d156b88a0bf1b5c0a904cbf4d01d";